import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const KioskFooter = ({ className = '' }) => {
  const [showPrivacyNotice, setShowPrivacyNotice] = useState(false);

  const currentYear = new Date()?.getFullYear();

  return (
    <>
      <footer className={`bg-surface border-t border-border ${className}`}>
        <div className="flex items-center justify-between h-16 px-6">
          {/* Company Info */}
          <div className="text-sm text-text-secondary">
            © {currentYear} PresenceControl. Alle Rechte vorbehalten.
          </div>

          {/* Privacy Notice Link */}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setShowPrivacyNotice(true)}
            iconName="Shield"
            iconPosition="left"
            className="text-text-secondary hover:text-text-primary touch-feedback"
          >
            Datenschutzhinweis
          </Button>

          {/* System Status */}
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full"></div>
            <span className="text-sm text-text-secondary">System online</span>
          </div>
        </div>
      </footer>

      {/* Privacy Notice Modal */}
      {showPrivacyNotice && (
        <div className="fixed inset-0 z-50 bg-background/95 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-card border border-border rounded-xl p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto elevation-3">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Shield" size={20} className="text-primary" />
                </div>
                <h2 className="text-xl font-semibold text-text-primary">
                  Datenschutzhinweis - DSGVO-Konformität
                </h2>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setShowPrivacyNotice(false)}
                iconName="X"
                className="touch-feedback"
              />
            </div>

            <div className="space-y-4 text-sm text-text-secondary">
              <div>
                <h3 className="font-medium text-text-primary mb-2">Datenerhebung</h3>
                <p>
                  Dieses Kiosksystem erfasst Mitarbeitercodes, Zeitstempel und Standortdaten 
                  zur Zeiterfassung. Alle Daten werden gemäß DSGVO und den Datenschutzrichtlinien 
                  Ihres Unternehmens verarbeitet.
                </p>
              </div>

              <div>
                <h3 className="font-medium text-text-primary mb-2">Datennutzung</h3>
                <p>
                  Ihre Zeiterfassungsdaten werden ausschließlich für Lohnabrechnung, Anwesenheitskontrolle 
                  und Compliance-Berichte verwendet. Eine Weitergabe an Dritte erfolgt nicht ohne ausdrückliche Zustimmung.
                </p>
              </div>

              <div>
                <h3 className="font-medium text-text-primary mb-2">Ihre Rechte</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>Recht auf Auskunft über Ihre personenbezogenen Daten</li>
                  <li>Recht auf Berichtigung unrichtiger Daten</li>
                  <li>Recht auf Löschung unter bestimmten Voraussetzungen</li>
                  <li>Recht auf Datenübertragbarkeit</li>
                  <li>Recht auf Widerspruch gegen die Verarbeitung</li>
                </ul>
              </div>

              <div>
                <h3 className="font-medium text-text-primary mb-2">Datensicherheit</h3>
                <p>
                  Alle Daten werden während der Übertragung und im Ruhezustand verschlüsselt.
                  Der Zugriff ist nur autorisiertem Personal gestattet. Regelmäßige Sicherheitsprüfungen stellen die Einhaltung von Branchenstandards sicher.
                </p>
              </div>

              <div>
                <h3 className="font-medium text-text-primary mb-2">Kontaktinformationen</h3>
                <p>
                  Für datenschutzbezogene Anfragen oder zur Ausübung Ihrer Rechte wenden Sie sich an die Personalabteilung 
                  oder den Datenschutzbeauftragten.
                </p>
              </div>
            </div>

            <div className="mt-6 pt-4 border-t border-border">
              <Button
                variant="default"
                size="lg"
                fullWidth
                onClick={() => setShowPrivacyNotice(false)}
                iconName="Check"
                iconPosition="left"
                className="touch-feedback"
              >
                Verstanden
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default KioskFooter;